module.exports = __webpack_public_path__ + "img/caimito-350x184.05a9c83d.jpg";